var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Create a new scenario")]),_c('scenario-form',{attrs:{"data":_vm.scenario,"show-back-button":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }